export default {"src":"/_next/static/media/dotted-bg.a18fa00f.svg","height":266,"width":1438,"blurWidth":0,"blurHeight":0};